export enum ListTypeEnum {
  Custom = 1,
  Sales = 128,
  Service = 256,
  'Car Alerts' = 512,
  ClientContacts = 1024,
}
